module.exports = PIXI;


/*****************
 ** WEBPACK FOOTER
 ** external "PIXI"
 ** module id = 1
 ** module chunks = 0
 **/